module.exports = __webpack_public_path__ + "img/products/step-05@2x.png";